import { v4 as uuidv4 } from 'uuid';
import AuthModule from '@modules/AuthModule';
import { getCorrectedNow } from '@modules/ServiceModule/workspace/lib/clientServerTimeDiff';
import { ITask } from '@modules/TasksModule/types';
import { UserActionDeviceType, UserActionEventType } from '../lib/types';
import { UserActionEventTable } from '../lib/UserActionEventTable';
import IAppLogger from '@app/lib/IAppLogger';

/**
 * Writes an AgentRejected event to IndexedDB when the agent rejects an incoming task.
 * The kazooCallId is read from task.attributes.remoteCallId, set at phone.call.placed time.
 * Timestamp is corrected for client/server clock skew via getCorrectedNow().
 */
const handleAgentRejected = async (
  task: ITask,
  table: UserActionEventTable,
  logger: IAppLogger,
): Promise<void> => {
  const userId = AuthModule.user?.id;
  if (!userId) return;

  const kazooCallId =
    typeof task.attributes?.remoteCallId === 'string'
      ? task.attributes.remoteCallId
      : undefined;
  if (!kazooCallId) {
    logger.warn(
      'IndexDbModule: handleAgentRejected — task missing remoteCallId, skipping event write',
    );
    return;
  }

  const timestamp = getCorrectedNow();

  try {
    await table.add({
      eventId: uuidv4(),
      kazooCallId,
      event: UserActionEventType.AgentRejected,
      timestamp,
      deviceType: UserActionDeviceType.Web,
      userId,
    });
  } catch (error) {
    logger.error('IndexDbModule: failed to write AgentRejected event', error);
  }
};

export default handleAgentRejected;
